import allIcon from "../assets/images/gym.png";
import backIcon from "../assets/images/back-exercise.png";
import cardioIcon from "../assets/images/cardio-exercise.png";
import chestIcon from "../assets/images/chest-exercise.png";
import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BodyPart = ({ bodyPart, item }) => {
  const exerciseGroup = [
    { item: "back", Icon: backIcon },
    { item: "all", Icon: allIcon },
    { item: "cardio", Icon: cardioIcon },
    { item: "chest", Icon: chestIcon },
  ];

  const getIcon = (item) => {
    const exercise = exerciseGroup.find((group) => group.item === item);
    return exercise?.Icon ? exercise?.Icon : allIcon;
  };

  const navigate = useNavigate();
  const bodyPartClickHandler = () => {
    item !== "all" ? navigate("./?bp=" + item) : navigate("./");
    document.getElementById("exercises").scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <Stack
      type="button"
      alignItems="center"
      justifyContent="center"
      className="bodyPart-card"
      sx={{
        borderTop: bodyPart === item ? "4px solid #ff2625" : "",
        backgroundColor: "#fff",
        borderBottomLeftRadius: "20px",
        width: "270px",
        height: "280px",
        cursor: "pointer",
        gap: "47px",
      }}
      onClick={bodyPartClickHandler}
    >
      <img
        style={{ width: "auto", height: "80px" }}
        src={getIcon(item)}
        alt="dumbbell"
      />
      <Typography fontSize="24px" fontWeight="bold" color="#3A1212">
        {item}
      </Typography>
    </Stack>
  );
};

export default BodyPart;
